import React from "react";
import { convertToRoman } from "../../utils/funcs";
import { chapterNames } from "../../utils/constants";

interface ChapterButtonsProps {
  activeContainer: number;
  activateContainer: (index: number) => void;
  caseName: any; // Can be CaseAttributes or other entity types
}

const chapterButtons: React.FC<ChapterButtonsProps> = ({
  activeContainer,
  activateContainer,
  caseName,
}) => {
  let mappableData: any[] = [];

  if (caseName) {
    const chaptersArray: number[] = [];

    chapterNames.forEach((chapterName, index) => {
      // Strapi 5: entities are flat, access properties directly
      const chapterData = caseName?.[chapterName];
      if (chapterData && Array.isArray(chapterData) && chapterData.length > 0) {
        chaptersArray.push(index + 1);
      }
    });

    mappableData = chaptersArray;
  }
  if (caseName?.textBlock) {
    mappableData = caseName.textBlock;
  }

  if (caseName?.headingTextBlock) {
    mappableData = caseName.headingTextBlock;
  }

  return (
    <div className="container text-center mt--100">
      {mappableData && mappableData.length > 0
        ? mappableData.map((item, index) => (
            <a
              key={`chapterButton${index}`}
              className={`btn-default ${
                activeContainer !== index ? "btn-border" : ""
              } size-md color-secondary ml--20 mt--20`}
              role="button"
              tabIndex={0}
              onClick={() => activateContainer(index)}
              onKeyDown={() => activateContainer(index)}
              href="#chapters"
            >
              {item.textBlock ? (
                <span>{item.heading}</span>
              ) : (
                <span>{convertToRoman(index + 1)}</span>
              )}
            </a>
          ))
        : ""}
    </div>
  );
};

export default chapterButtons;
